export default "__VITE_ASSET__c7Klvux2__"